// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"364":"399f6acf","496":"1e53002a","651":"ce3b628a","657":"f5d817a3","851":"b5728b4d"}[chunkId] + ".chunk.js";
};